import api from '../BaseUrl';

export interface Message {
  id: number;
  name: string;
  email: string;
  phone: string;
  subject: string;
  description: string;
  /** UTC, set by the server */
  createDate: string;
  isRead: boolean;
}

export interface MessageSummary {
  id: number;
  name: string;
  subject: string;
  createDate: string;
}

export interface MessageNotifications {
  unreadCount: number;
  latest: MessageSummary[];
}

export const getMessages = async (): Promise<Message[]> => {
  const res = await api.get<Message[]>('/api/Admin/GetMessages');
  return res.data;
};

export const getMessageNotifications = async (): Promise<MessageNotifications> => {
  const res = await api.get<MessageNotifications>('/api/Admin/GetMessageNotifications');
  return res.data;
};

export const markMessageRead = async (id: number): Promise<void> => {
  await api.put(`/api/Admin/MarkMessageRead/${id}`);
  notifyMessagesChanged();
};

export const deleteMessage = async (id: string | number): Promise<void> => {
  await api.delete(`/api/Admin/DeleteMessage/${id}`);
  notifyMessagesChanged();
};

/** Fired after a message is read or deleted so the bell in the header refreshes. */
export const MESSAGES_CHANGED = 'admin:messages-changed';

export const notifyMessagesChanged = () => window.dispatchEvent(new Event(MESSAGES_CHANGED));
